import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=5a4e2315"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a4e2315')) {
      api.createRecord('5a4e2315', component.options)
    } else {
      api.reload('5a4e2315', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=5a4e2315", function () {
      api.rerender('5a4e2315', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/footer/type_1/Footer.vue"
export default component.exports